import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    showSearchMenu: {
      show: false,
      style: "background-color: #5d6367; color: #cecece"
    },
    reloadPage: false,
    showHeader: true,
    elementToSearchOfGridMenu: [],
    requestAdded: false,
    languageChanged: false
  },

  mutations: {
    SET_showSearchMenu: (state, payload) => {
      state.showSearchMenu = payload;
    },
    SET_reloadPage:  (state, payload) => {
      state.reloadPage = payload;
    },
    SET_showHeader:  (state, payload) => {
      state.showHeader = payload;
    },
    SET_elementToSearchOfGridMenu: (state, payload) => {
      state.elementToSearchOfGridMenu = payload;
    },
    SET_requestAdded: (state, payload) => {
      state.requestAdded = payload;
    },
    // language
    SET_languageChanged: (state, payload) => {
      state.languageChanged = payload;
    }
  },
  getters: {

    GET_showSearchMenu: state => {
      return state.showSearchMenu;
    },
    GET_reloadPage: state => {
      return state.reloadPage;
    },
    GET_showHeader: state => {
      return state.showHeader;
    },
    GET_elementToSearchOfGridMenu: state => {
      return state.elementToSearchOfGridMenu;
    },
    GET_requestAdded: state => {
      return state.requestAdded;
    },
    // language
    GET_languageChanged: state => {      
      return state.languageChanged;
    }
  },
  actions: {

  },
});
